/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the currently selected order
 * @returns {OrderEntity | null} The `order` that has been selected from the store
 */
const ordersSelectedSelector = createSelector(ordersSelector, (orders) => orders.selectedIds[0]);

export default ordersSelectedSelector;
